import React, { useCallback, useState, useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { useDropzone } from 'react-dropzone'
import './custom-dropzone.scss'
import { v4 as uuidv4 } from 'uuid'
import getCurrentUser from '../../utils/getCurrentUser'
import {
  registerPermanentbooking,
  getPermanentBookingFileList
} from "../../services/permanentService";
import {
  getToastSuccess,
  getToastError
} from '../../redux/actions/toastActions';
import LoadingIndicator from "../LoadingIndicator";
import { t } from 'i18next';
import uploadIconBlack from "../../assets/images/uploadIconBlack.svg";
import excel from '../../assets/images/excel.png';
import * as XLSX from "xlsx"; 

const CustomDropzone = ({
  setDisplayUploadSection,
  toastDetails,
  getToastSuccess,
  getToastError,
  setDropDownFileList,
  setListPageOpen,
  setFileName,
  fileList,
  handleFileNameSelect,
}) => {

  const [file, setFile] = useState(null);
  const [isLoading, setLoading] = useState(false);

  // const onDrop = useCallback((acceptedFiles) => {
  //   if (acceptedFiles && acceptedFiles.length) {
  //     acceptedFiles.forEach((file) => {
  //       const filepathArray = file.path.split('.')
  //       if (filepathArray[filepathArray.length - 1] !== 'xlsx' &&
  //         filepathArray[filepathArray.length - 1] !== 'xlx'
  //       ) {
  //         setFile(null)
  //         return
  //       }
  //       setFile(file)
  //       const reader = new FileReader()
  //       reader.onabort = () => console.log('file reading was aborted')
  //       reader.onerror = () => console.log('file reading has failed')
  //       reader.onload = async () => {
  //         const data = reader.result;
  //         const workbook = XLSX.read(data, { type: "array" });

  //         // Find the sheet named "Loose" (case-insensitive)
  //         const looseSheetName = workbook.SheetNames.find(
  //           name => name.toLowerCase() === "loose"
  //         );

  //         if (looseSheetName) {
  //           const worksheet = workbook.Sheets[looseSheetName];
  //           const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "", header: 1 });

  //           // 1. Find the header row index and the indices for the SHC columns
  //           let headerRowIndex = -1;
  //           let shcIndices = [];
  //           const shcHeaders = ["addn.shc1", "shc2", "shc3"];
  //           for (let i = 0; i < jsonData.length; i++) {
  //             const row = jsonData[i];
  //             let foundIndices = shcHeaders.map(header =>
  //               row.findIndex(
  //                 col => col && col.toString().replace(/\s+/g, '').toLowerCase() === header
  //               )
  //             );
  //             if (foundIndices.some(idx => idx !== -1)) {
  //               headerRowIndex = i;
  //               shcIndices = foundIndices;
  //               break;
  //             }
  //           }

  //           // 2. If found, check all rows below header for BUP in any SHC column
  //           let hasBUP = false;
  //           if (headerRowIndex !== -1 && shcIndices.some(idx => idx !== -1)) {
  //             for (let i = headerRowIndex + 1; i < jsonData.length; i++) {
  //               const row = jsonData[i];
  //               for (let idx of shcIndices) {
  //                 if (
  //                   idx !== -1 &&
  //                   row[idx] &&
  //                   row[idx].toString().toUpperCase().trim() === "BUP"
  //                 ) {
  //                   hasBUP = true;
  //                   break;
  //                 }
  //               }
  //               if (hasBUP) break;
  //             }
  //           }

  //           console.log("hasBUP", hasBUP);  

  //           if (hasBUP) {
  //             setFile(null);
  //             getToastError("Loose booking is not supported for SCC which is BUP.");
  //             return;
  //           }
  //         }

  //         // If valid, continue with upload
  //         handleUploadFile(file);
  //       }
  //       reader.readAsArrayBuffer(file)
  //     })
  //   }
  // }, [fileList]) 


  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length) {
      acceptedFiles.forEach((file) => {
        const filepathArray = file.path.split('.')
        if (filepathArray[filepathArray.length - 1] !== 'xlsx' &&
          filepathArray[filepathArray.length - 1] !== 'xlx'
        ) {
          setFile(null)
          return
        }
        setFile(file)
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result
        }
        reader.readAsArrayBuffer(file)
        handleUploadFile(file)
      })
    }
  }, [])


  const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: false })
  // useEffect(() => {
  // 	if (toastDetails && toastDetails.severity) {
  // 		// myToast.current.show({ ...toastDetails, life: 4000 })
  // 	}
  // }, [toastDetails])

  useEffect(() => {
    getPermanentBookingFileList().then((res) => {
      if (res && res.permanentBookingDetails) {
        setDropDownFileList(res.permanentBookingDetails);
      }
    })
  }, [])

  const handleUploadFile = (props) => {
    setDisplayUploadSection(false);
    saveExcelData(props);
  }

  const saveExcelData = (file) => {

    //send excell file to api
    let userDetails = getCurrentUser();

    var formData = new FormData();

    formData.append("requestID", uuidv4());
    formData.append("userId", userDetails.userId);
    formData.append("agentCode", userDetails.agentCode);
    formData.append("fileName", file.name);
    formData.append("saveMassBookingExcel", file);
    formData.append("emailId", userDetails.email);
    formData.append("firstName", userDetails.firstName);

     console.log("formData",formData)

    const checkFileName = () => {
      let isFileExists = false
      fileList.map(item => {
        ///console.log(item.fileName,"item")
        if (item.fileName === file.name) {
          //
          isFileExists = true


          // console.log("not submitted", file.name)
        }
      })
      return isFileExists
    }
    //  console.log(checkFileName(), "checkFileName")
    if (checkFileName() === true) {
      //alert("File Name already Exists");
      getToastError("File already Exists");
    }
    else {


      setLoading(true);

      registerPermanentbooking(formData).then((res) => {


        if (res?.status === 200) {
          setLoading(false);
          //call toaster
          getToastSuccess("File uploaded successfully");
          /*getPermanentBookingFileList().then((res) => {
            setDropDownFileList(res.permanentBookingDetails);
          })*/
          setFile(null);
          setListPageOpen(true);
          setFileName(file.name);

          setTimeout(() => {
            getPermanentBookingFileList().then((res) => {
              if (res && res.permanentBookingDetails) {
                setDropDownFileList(res.permanentBookingDetails);
              }
            })
          }, 1000);
          //console.log(file, "path")
          // setTimeout(() => {
          //   handleFileNameSelect(file.name)
          // },500)

        }
      }).catch((error) => {
        getToastError("Failed to upload file");
      })
    }
  }


  return (
    <>
      {
        isLoading ? <LoadingIndicator /> : ''
      }
      <div className='dg-upload-body w-100'>
        {
          file ?
            (
              <ul className='dg-up-file-list'>
                <li className="dg-up-file">
                  <div className="up-file-details" >
                    <img src={excel} />
                    <span> {file.name}</span>
                    <span
                      className='up-file-delete'
                      onClick={(e) =>
                        setFile(null)}
                    >{t('COMMON.DELETE')}</span>
                  </div>
                </li>
              </ul>
            ) : <></>
        }
        <div className='file-upload-block'>
          <div className='upload-content-block' {...getRootProps()}>
            <input {...getInputProps()} id='custom-drop-zone' />
            <img
              src={uploadIconBlack}
              alt="upload"
              title="upload"
              id="upload-icon"
            />
            <div className="upload-drop-label">
              <label className="upload-label" >
                {t('COMMON.UPLOAD_CLICK')}
              </label>
              <label className="drop-label">{t('COMMON.UPLOAD_DROP')}</label>
            </div>
            <label className="drop-label">
              {t('COMMON.UPLOAD_XLS_INFO')}
            </label>
          </div>
        </div>

      </div>
    </>
  )
}

const mapStateToProps = ({ loader, toast }) => ({
  //	principal: auth.principal,
  //	isLoading: loader.isLoading,
  toastDetails: toast.toastDetails,
})

const mapDispatchToProps = (dispatch) => ({
  getToastSuccess: (message) => {
    dispatch(getToastSuccess(message))
  },
  getToastError: (message) => {
    dispatch(getToastError(message))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomDropzone)
